// Who last signed in on this browser, kept after the auth cookies expire so
// the public planner can tell a returning dispatcher that they are planning
// without their company's settings. Holds no secret.

const EMAIL_KEY = "lastSignedInEmail"
const DISMISSED_KEY = "rememberedAccountNoticeDismissedAt"
const DISMISS_FOR_MS = 7 * 24 * 60 * 60 * 1000

export function rememberAccount(email: string): void {
  localStorage.setItem(EMAIL_KEY, email)
}

export function getRememberedEmail(): string | null {
  return localStorage.getItem(EMAIL_KEY)
}

export function dismissAccountNotice(now = Date.now()): void {
  localStorage.setItem(DISMISSED_KEY, String(now))
}

export function isAccountNoticeDismissed(now = Date.now()): boolean {
  const dismissedAt = Number(localStorage.getItem(DISMISSED_KEY))
  return dismissedAt > 0 && now - dismissedAt < DISMISS_FOR_MS
}
